// plugins/05.requestRepository.ts
import repositories from '~/repositories/'

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.provide('repository', repositories(nuxtApp.$axios, nuxtApp.$fetchLotteries))
})
